import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import {
  DesignerUIStateActions,
  useDesignerUIContext,
} from '../../../../hooks/useDesignerUIState';
import { Button } from '../../../_atoms/Button';

const SLIDE_COLORS_SELECTION = [
  '#5622E2',
  '#139982',
  '#F1975C',
  '#f9f3eb',
  '#1D49A7',
  '#C61608',
  '#282F33',
  '#EC635E',
  '#FFFFFF',
  '#ED70C0',
  '#BF71E0',
  '#8555F7',
  '#5870F7',
  '#94D769',
  '#FAE070',
];
const ColorPickerRow = ({
  onColorSelected,
}: {
  onColorSelected: (color: string) => void;
}) => {
  const { t } = useTranslation('Host');
  const dispatch = useDesignerUIContext(context => context.dispatch);
  const onClickSeeMore = useCallback(() => {
    dispatch({
      type: DesignerUIStateActions.deselectElements,
    });
    dispatch({
      type: DesignerUIStateActions.setSelectedTab,
      payload: { tab: 'colorPicker', extraState: 'backgroundSelector' },
    });
  }, [dispatch]);
  return (
    <div style={{ height: '100px', marginTop: '10px' }}>
      <TitleContainer>
        <span style={{ padding: '1%' }}>Colors</span>
        <Button
          onClick={() => {
            onClickSeeMore();
          }}
          styles={{ fontSize: 12 }}
          type="ghost"
        >
          {t('Browse all')}
        </Button>
      </TitleContainer>
      <ScrollContainer>
        <ExampleImageContainer>
          {SLIDE_COLORS_SELECTION.map((color, i) => {
            return (
              <ColorItem
                $color={color}
                key={i}
                onClick={() => {
                  onColorSelected(color);
                }}
              ></ColorItem>
            );
          })}
        </ExampleImageContainer>
      </ScrollContainer>
    </div>
  );
};

const TitleContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;

  button {
    border: none;
    padding: 0px 10px;
    margin-bottom: 2px;
    box-shadow: none;
  }
`;

const ExampleImageContainer = styled.div`
  width: fit-content;
  display: flex;
  gap: 10px;
  justify-content: space-between;
  background-color: white;
`;
const ColorItem = styled.div<{ $color: string }>`
  cursor: pointer;

  background-color: ${({ $color }) => $color};
  width: 110px;
  height: 75px;
  border: solid 1px lightgray;
  border-radius: 10px;
`;
const ScrollContainer = styled.div`
  border-radius: 5px;
  overflow-x: scroll;
  scrollbar-width: none;
`;

export default ColorPickerRow;
